import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as boardService from '../../../services/board-service';
import {
    SEARCH_BOARDS_REQUEST,
    SEARCH_BOARDS_SUCCESS,
    SEARCH_BOARDS_FAILURE,
    FETCH_BOARD_REQUEST,
    FETCH_BOARD_SUCCESS,
    FETCH_BOARD_FAILURE,
    CREATE_BOARD_REQUEST,
    CREATE_BOARD_SUCCESS,
    CREATE_BOARD_FAILURE,
    UPDATE_BOARD_REQUEST,
    UPDATE_BOARD_SUCCESS,
    UPDATE_BOARD_FAILURE,
    DELETE_BOARD_REQUEST,
    DELETE_BOARD_SUCCESS,
    DELETE_BOARD_FAILURE
} from '../actions/board-actions';

function* searchBoardsSaga(action) {
    try {
        const data = yield call(boardService.searchBoards, action.payload);
        yield put({ type: SEARCH_BOARDS_SUCCESS, payload: data });
    } catch (error) {
        yield put({ type: SEARCH_BOARDS_FAILURE, payload: error.message });
        toast.error('Failed to fetch boards');
    }
}

function* fetchBoardSaga(action) {
    try {
        const data = yield call(boardService.fetchBoardById, action.payload);
        yield put({ type: FETCH_BOARD_SUCCESS, payload: data });
    } catch (error) {
        yield put({ type: FETCH_BOARD_FAILURE, payload: error.message });
        toast.error('Failed to fetch board');
    }
}

function* createBoardSaga(action) {
    try {
        const data = yield call(boardService.createBoard, action.payload);
        yield put({ type: CREATE_BOARD_SUCCESS, payload: data });
        toast.success('Board created successfully');
    } catch (error) {
        yield put({ type: CREATE_BOARD_FAILURE, payload: error.message });
        toast.error('Failed to create board');
    }
}

function* updateBoardSaga(action) {
    try {
        const { id, data } = action.payload;
        const result = yield call(boardService.updateBoard, id, data);
        yield put({ type: UPDATE_BOARD_SUCCESS, payload: result });
        toast.success('Board updated successfully');
    } catch (error) {
        yield put({ type: UPDATE_BOARD_FAILURE, payload: error.message });
        toast.error('Failed to update board');
    }
}

function* deleteBoardSaga(action) {
    try {
        yield call(boardService.deleteBoard, action.payload);
        yield put({ type: DELETE_BOARD_SUCCESS, payload: action.payload });
        toast.success('Board deleted successfully');
    } catch (error) {
        yield put({ type: DELETE_BOARD_FAILURE, payload: error.message });
        toast.error('Failed to delete board');
    }
}

export default function* boardSaga() {
    yield takeLatest(SEARCH_BOARDS_REQUEST, searchBoardsSaga);
    yield takeLatest(FETCH_BOARD_REQUEST, fetchBoardSaga);
    yield takeLatest(CREATE_BOARD_REQUEST, createBoardSaga);
    yield takeLatest(UPDATE_BOARD_REQUEST, updateBoardSaga);
    yield takeLatest(DELETE_BOARD_REQUEST, deleteBoardSaga);
}
